import { Check } from "lucide-react";

/**
 * Shared multi-step policy wizard shell — PaceHRM design-system chrome.
 */
export default function PolicyFormWizardShell({
  darkMode = false,
  steps = [],
  currentStep = 1,
  onStepClick,
  children,
  policySaveError,
  footer,
  wizardLabel = "Policy wizard",
  contentClassName = "",
}) {
  void darkMode;

  return (
    <div className="flex min-h-0 flex-1 flex-col bg-[hsl(var(--ds-muted)/0.35)] px-6 py-4 text-[12px] leading-snug text-[hsl(var(--ds-fg))]">
      <div className="flex-shrink-0 rounded-3xl border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] p-4 shadow-[var(--ds-shadow-card)]">
        <div className="mb-2 flex items-center justify-between gap-2">
          <p className="text-xs font-semibold uppercase tracking-wide text-[hsl(var(--ds-muted-fg))]">
            {wizardLabel}
          </p>
          <p className="text-[11px] text-[hsl(var(--ds-muted-fg))]">
            Step {currentStep} of {steps.length}
          </p>
        </div>
        <div className="flex items-center justify-between gap-1 overflow-x-auto pb-1">
          {steps.map((step, idx) => (
            <div key={step.id} className="flex flex-shrink-0 items-center">
              <button
                type="button"
                onClick={() => onStepClick?.(step.id)}
                disabled={step.id > currentStep}
                className={`flex min-w-[56px] flex-col items-center ${
                  step.id <= currentStep ? "cursor-pointer" : "cursor-default"
                }`}
                title={step.label}
              >
                <span
                  className={`flex h-8 w-8 items-center justify-center rounded-full border-2 text-[11px] font-semibold ${
                    currentStep === step.id
                      ? "border-[hsl(var(--ds-primary))] bg-[hsl(var(--ds-accent))] text-[hsl(var(--ds-primary))]"
                      : currentStep > step.id
                        ? "border-[hsl(var(--ds-success))] bg-[hsl(var(--ds-success)/0.12)] text-[hsl(var(--ds-success))]"
                        : "border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-muted))] text-[hsl(var(--ds-muted-fg))]"
                  }`}
                >
                  {currentStep > step.id ? <Check size={14} /> : step.id}
                </span>
                <span
                  className={`mt-1 max-w-[72px] text-center text-[9px] leading-tight ${
                    currentStep === step.id
                      ? "font-medium text-[hsl(var(--ds-fg))]"
                      : "text-[hsl(var(--ds-muted-fg))]"
                  }`}
                >
                  {step.shortLabel}
                </span>
              </button>
              {idx < steps.length - 1 && (
                <div
                  className={`mx-0.5 mb-4 h-0.5 w-5 sm:w-8 ${
                    currentStep > step.id
                      ? "bg-[hsl(var(--ds-success))]"
                      : "bg-[hsl(var(--ds-border))]"
                  }`}
                />
              )}
            </div>
          ))}
        </div>
        <p className="mt-1 text-center text-[11px] text-[hsl(var(--ds-muted-fg))]">
          Step {currentStep} of {steps.length}:{" "}
          <span className="font-medium text-[hsl(var(--ds-fg))]">
            {steps[currentStep - 1]?.label}
          </span>
        </p>
      </div>

      <div
        className={`mt-3 max-h-[min(58vh,560px)] min-h-[300px] flex-1 overflow-y-auto rounded-3xl border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] p-5 shadow-[var(--ds-shadow-card)] ${contentClassName}`}
      >
        {children}
      </div>

      <div className="mt-3 flex flex-shrink-0 flex-wrap items-center justify-end gap-2 border-t border-[hsl(var(--ds-border))] px-1 py-2">
        {policySaveError && (
          <p className="mr-auto w-full text-sm text-[hsl(var(--ds-danger))] sm:w-auto">
            {policySaveError}
          </p>
        )}
        {footer}
      </div>
    </div>
  );
}
